<template>
  <div>
    <h1 class="mb-2 mt-1">Counterparty Data</h1>

    <category-summary-table
      :hint-id="13"
      category="counterparty"
      route-name="counterparty-details"
      param-name="cid"
      name-label="Counterparty"
    >
      <template #title>
        Counterparties
      </template>
    </category-summary-table>
  </div>
</template>

<script>
import CategorySummaryTable from './CategorySummaryTable.vue'

export default {
  components: {
    CategorySummaryTable,
  },
}
</script>
